import { zSchema, schemes } from "@zeal/common";

export const submitOrderRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  orderID: schemes.uuid(),
});

export type TSubmitOrderRequestSchema = zSchema.infer<
  typeof submitOrderRequestSchema
>;

export const submitOrderResponseSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  orderID: schemes.uuid(),
  businessCardID: zSchema.string().optional(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
  flat: zSchema.number(),
  last_four: zSchema.string().optional(),
  memo: zSchema.string().optional(),
  order_total: zSchema.number(),
  payment_receipt_link: zSchema.string().nullable(),
  status: zSchema.string(),
  submitted_at: zSchema.date().optional(),
});

export type TSubmitOrderResponseSchema = zSchema.infer<
  typeof submitOrderResponseSchema
>;
